import { useScrollReveal } from '../../../hooks/useScrollReveal';

export default function CTASection() {
  const ref = useScrollReveal();

  return (
    <section className="w-full bg-[#FAFAFA] py-16 px-6">
      <div ref={ref} className="section-reveal max-w-xl mx-auto text-center">
        <p className="text-xs font-medium text-[#9A9A9A] tracking-[0.2em] uppercase mb-8">Follow</p>

        <div className="text-xl md:text-2xl font-bold text-[#1A1A1A] leading-relaxed tracking-wide mb-6">
          あなたに合った場所で、<br />
          つながってください。
        </div>

        <p className="text-[14px] md:text-[15px] leading-[1.95] text-[#6B6B6B] mb-10">
          ブログ、Instagram、X、TikTok、YouTube——<br className="hidden sm:block" />
          それぞれの媒体で、Apple製品やガジェットに関する情報を発信しています。<br className="hidden sm:block" />
          お気に入りの場所で、気軽にフォローしていただけると嬉しいです。
        </p>


      </div>
    </section>
  );
}
